import { render, staticRenderFns } from "./PowerBIViewList.vue?vue&type=template&id=2b31650e"
import script from "./PowerBIViewList.vue?vue&type=script&lang=js"
export * from "./PowerBIViewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports